var render = function render() {
  var _vm$State$config, _vm$State$config$feat, _vm$State$partyJoinIn, _vm$State$config2, _vm$State$config2$fea, _vm$State$partyJoinIn2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.aiSpeechLoading,
      expression: "aiSpeechLoading"
    }],
    ref: "aiSpeechBox",
    staticClass: "aiSppechBox scrollbar",
    class: {
      manageGrayScroll: _vm.$route.name === 'manage'
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm$State$config = _vm.State.config) !== null && _vm$State$config !== void 0 && (_vm$State$config$feat = _vm$State$config.features) !== null && _vm$State$config$feat !== void 0 && _vm$State$config$feat.stt && ((_vm$State$partyJoinIn = _vm.State.partyJoinInfo) === null || _vm$State$partyJoinIn === void 0 ? void 0 : _vm$State$partyJoinIn.channelMode) === 0 ? _c('div', {
    staticClass: "aiSppech"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.title')))]), !_vm.sttFeatureControl ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('aiSpeech.diabledTitle'),
      "placement": "top"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F",
      "disabled": !_vm.sttFeatureControl
    },
    on: {
      "change": _vm.controlAISpeech
    },
    model: {
      value: _vm.defaultSwitch.aiSpeech,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "aiSpeech", $$v);
      },
      expression: "defaultSwitch.aiSpeech"
    }
  })], 1) : _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F",
      "disabled": !_vm.sttFeatureControl
    },
    on: {
      "change": _vm.controlAISpeech
    },
    model: {
      value: _vm.defaultSwitch.aiSpeech,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "aiSpeech", $$v);
      },
      expression: "defaultSwitch.aiSpeech"
    }
  })], 1), _vm.sttFeatureControl ? _c('div', {
    staticClass: "langBox"
  }, [_c('span', {
    staticClass: "langInput"
  }, [_vm._v(_vm._s(_vm.$t('common.inputLanguage')))]), _c('el-checkbox-group', {
    attrs: {
      "max": 3
    },
    model: {
      value: _vm.langVal,
      callback: function ($$v) {
        _vm.langVal = $$v;
      },
      expression: "langVal"
    }
  }, _vm._l(_vm.langArray, function (lang) {
    return _c('el-checkbox', {
      key: lang.val,
      staticClass: "greenStyle",
      attrs: {
        "disabled": _vm.defaultSwitch.aiSpeech || lang.val == 'en-US',
        "label": lang.val
      }
    }, [_vm._v(_vm._s(_vm.$t(`aiSpeech.${lang.label}`)))]);
  }), 1)], 1) : _vm._e(), _c('div', {
    staticClass: "text"
  }, [_vm.sttFeatureControl ? _c('div', [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.aiSpeech')))])])]) : _c('div', [_c('div', {
    staticClass: "leftText"
  }, [_vm._v(" " + _vm._s(_vm.$t('setting.contactFeatureContent')) + " ")]), _c('a', {
    staticStyle: {
      "color": "#017AFF !important"
    },
    attrs: {
      "href": "mailto:support@tvunetworks.com",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.contactEmail')))])])]), (_vm$State$config2 = _vm.State.config) !== null && _vm$State$config2 !== void 0 && (_vm$State$config2$fea = _vm$State$config2.features) !== null && _vm$State$config2$fea !== void 0 && _vm$State$config2$fea.voiceCommand && ((_vm$State$partyJoinIn2 = _vm.State.partyJoinInfo) === null || _vm$State$partyJoinIn2 === void 0 ? void 0 : _vm$State$partyJoinIn2.channelMode) === 0 && _vm.defaultSwitch.aiSpeech && _vm.sttFeatureControl ? _c('div', {
    staticClass: "voiceCommand"
  }, [_c('h4', {
    staticClass: "commonTitle"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('voiceCommand.title')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.controlAIVoiceCommand
    },
    model: {
      value: _vm.defaultSwitch.voiceCommand,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "voiceCommand", $$v);
      },
      expression: "defaultSwitch.voiceCommand"
    }
  })], 1), _c('div', {
    staticClass: "commonText"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('voiceCommand.tips')))])])]), _c('div', {
    staticClass: "step first"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step1')))]), _c('div', {
    staticClass: "stepText"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step1Text')))]), _c('div', {
    staticClass: "selectParticipant"
  }, [_c('span', {
    staticClass: "titles"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.selectParticipant')))]), _c('el-select', {
    staticClass: "participantSelect",
    attrs: {
      "multiple": "",
      "size": "small",
      "popper-class": "whiteStyle",
      "no-data-text": _vm.$t('galleryHost.noParticipant')
    },
    on: {
      "change": _vm.setVoiceCommand
    },
    model: {
      value: _vm.selectParticipantArray,
      callback: function ($$v) {
        _vm.selectParticipantArray = $$v;
      },
      expression: "selectParticipantArray"
    }
  }, _vm._l(_vm.State.allRtilCodes, function (rtilCode) {
    return _c('el-option', {
      key: rtilCode,
      attrs: {
        "label": _vm.State.globalNameInfo[rtilCode] || rtilCode,
        "value": rtilCode
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "step"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step2')))]), _c('div', {
    staticClass: "stepText"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step2Text')))]), _c('div', {
    staticClass: "producerSelectBox",
    attrs: {
      "id": "productionId"
    }
  }, [_c('span', {
    staticClass: "selectBoxText"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.SelectProducerProgram')))]), _c('el-select', {
    staticClass: "producerSelect",
    attrs: {
      "popper-class": "producerPopper",
      "no-data-text": _vm.$t('common.noProgram')
    },
    on: {
      "visible-change": _vm.getProducerList,
      "change": _vm.saveProducerId
    },
    model: {
      value: _vm.productionId,
      callback: function ($$v) {
        _vm.productionId = $$v;
      },
      expression: "productionId"
    }
  }, _vm._l(_vm.ppList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "step"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step3')))]), _c('div', {
    staticClass: "stepText"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step3Text'))), _c('span', {
    staticClass: "magicWord greenColor"
  }, [_vm._v(" \"Hi Al\".")])]), _c('div', {
    staticClass: "step"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step4')))]), _c('div', {
    staticClass: "stepText"
  }, [_vm._v(_vm._s(_vm.$t('voiceCommand.step4Text')))]), _c('div', {
    staticClass: "suggestionBox"
  }, _vm._l(_vm.suggestionArray, function (item) {
    return _c('div', {
      key: item.label,
      staticClass: "suggestionLi"
    }, [_c('span', {
      staticClass: "liSpan"
    }, [_vm._v("\"" + _vm._s(_vm.$t(`voiceCommand.${item.label1}`)) + "\"")]), _c('span', {
      staticClass: "liSpan"
    }, [_vm._v(_vm._s(_vm.$t(`voiceCommand.${item.label2}`)))])]);
  }), 0)]) : _vm._e()]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };